module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), (!_vm.gallery_view) ? _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('section', {
    staticStyle: {
      "height": "88vh"
    },
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url(' + _vm.set_gallery_banner_image + ')'
    }),
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "sign-up-form",
    staticStyle: {
      "height": "88vh"
    }
  }, [_c('h2', [_vm._v("Explore")]), _vm._v(" "), _c('div', {
    staticClass: "line-divider"
  }), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "gw-block"
  }, [_vm._l((_vm.galleria), function(gallery, gndex) {
    return _c('div', {
      staticClass: "folder-main col-sm-6 col-xs-6 col-md-4"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getPostsInGallery(gallery)
        }
      }
    }, [_c('div', {
      staticClass: "folder-inner"
    }, [(gallery.gallery_posts_group_posts_media.length > 0) ? _c('div', {
      staticClass: "folder-inner-image"
    }, [(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticClass: "folder-inner-image"
    }, [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "folder-inner-words"
    }, [_c('h5', [_c('a', {
      on: {
        "click": function($event) {
          _vm.getPostsInGallery(gallery)
        }
      }
    }, [_vm._v(_vm._s(gallery.gallery_posts_group_name))])])])])])])
  }), _vm._v(" "), (_vm.galleria.length == 0) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('p', [_vm._v("Loading gallery ...")])]) : _vm._e()], 2)])])])]) : _c('div', {
    attrs: {
      "id": "galleryview"
    }
  }, [_c('div', {
    staticClass: "gallery-view gw-not-mobile",
    staticStyle: {
      "background": "#000000"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "4em",
      "margin-bottom": "1em"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('close-gallery-view', '')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "margin-top": "3em"
    }
  }, [(_vm.gallery.gallery_posts_group_posts) ? _c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-8 offset-md-1"
  }, [(_vm.gallery.gallery_posts_group_posts.length > 1) ? _c('ul', {
    staticClass: "post-media-list"
  }, _vm._l((_vm.gallery.gallery_posts_group_posts), function(post, prdex) {
    return _c('li', {
      key: _vm.componentKey,
      staticStyle: {
        "color": "#cccccc"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.showPost(post)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-circle-o"
    })])])
  })) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.gallery_post.gallery_post_product_items) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "height": "600px",
      "overflow": "hidden"
    }
  }, [_c('div', [((_vm.gallery_post_set_image.gallery_post_media) && (_vm.gallery_post_set_image.gallery_post_media != '')) ? _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "100%",
      "min-height": "90%"
    }
  }, [(_vm.checkIfVideo(_vm.gallery_post_set_image.gallery_post_media)) ? _c('video', {
    attrs: {
      "width": "420",
      "height": "320",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.gallery_post_set_image.gallery_post_media,
      "type": "video/mp4"
    }
  })]) : _c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.gallery_post_set_image.gallery_post_media,
      "alt": ""
    }
  })]) : _c('div', [_c('img', {
    staticClass: "sp-prd-img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "height": "600px",
      "overflow": "hidden"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-size": "28px",
      "color": "#ffffff"
    }
  }, [_vm._v(_vm._s(_vm.gallery_post.gallery_post_caption) + "\r\n                                    "), (_vm.gallery_post.gallery_post_product_items) ? _c('span', [_vm._v("(£" + _vm._s(_vm.gallery_post.gallery_post_product_items[0].product_item_price) + ")")]) : _vm._e()]), _vm._v(" "), ((_vm.gallery_post.gallery_post_media) && (_vm.gallery_post.gallery_post_media != '')) ? _c('div', {
    staticClass: "row"
  }, [(_vm.gallery_post.gallery_post_media.length > 1) ? _c('ul', {
    staticClass: "post-menu-list"
  }, _vm._l((_vm.gallery_post.gallery_post_media), function(img, imdex) {
    return _c('li', {
      staticStyle: {
        "border": "solid 1px #cccccc"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showPostImage(img)
        }
      }
    }, [(_vm.checkIfVideo(img.gallery_post_media)) ? _c('img', {
      staticClass: "rounded",
      staticStyle: {
        "width": "2em",
        "height": "2em",
        "object-fit": "cover"
      },
      attrs: {
        "src": "/static/assets/images/video-placeholder.png",
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "rounded",
      staticStyle: {
        "width": "2em",
        "height": "2em",
        "object-fit": "contain"
      },
      attrs: {
        "src": img.gallery_post_media,
        "alt": ""
      }
    })])])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-right",
    staticStyle: {
      "margin-top": "1em",
      "color": "#ffffff"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#dad6d6",
      "font-size": "16px",
      "white-space": "pre-line"
    }
  }, [_vm._v(_vm._s(_vm.gallery_post.gallery_post_details))])])])]) : _c('div', {
    key: _vm.componentKey,
    attrs: {
      "id": "here"
    }
  }, [_c('component-product', {
    attrs: {
      "productMain": _vm.gallery_post.gallery_post_product_details
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "gallery-view gw-mobile"
  }, [_c('a', {
    staticClass: "closebtn",
    staticStyle: {
      "cursor": "pointer",
      "margin-top": "-1.5em",
      "z-index": "9"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('close-gallery-view', '')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "container gw-mobile",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.gallery.gallery_posts_group_type == 1) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "swiper-pagination",
    staticStyle: {
      "margin-left": "0.2em",
      "text-align": "center"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('swiper', {
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.gallery.gallery_posts_group_posts), function(post, pdex) {
    return _c('swiper-slide', {
      key: post.gallery_post_id
    }, [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "display": "block",
        "width": "100%"
      }
    }, [(post.gallery_post_media[0]) ? _c('div', {
      staticClass: "image",
      staticStyle: {
        "height": "250px",
        "width": "100%",
        "overflow-y": "scroll"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "image",
      staticStyle: {
        "min-height": "250px",
        "width": "100%"
      }
    }, [((_vm.gallery_post_set_image.gallery_post_media) && (post.gallery_post_id == _vm.gallery_post_set_image.gallery_post_media_post)) ? _c('div', [(_vm.checkIfVideo(_vm.gallery_post_set_image.gallery_post_media)) ? _c('video', {
      attrs: {
        "width": "480",
        "height": "240",
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": _vm.gallery_post_set_image.gallery_post_media,
        "type": "video/mp4"
      }
    })]) : _c('img', {
      staticClass: "rounded",
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "object-fit": "cover"
      },
      attrs: {
        "src": _vm.gallery_post_set_image.gallery_post_media,
        "alt": ""
      }
    })]) : _c('div', [(_vm.checkIfVideo(post.gallery_post_media[0].gallery_post_media)) ? _c('video', {
      attrs: {
        "width": "480",
        "height": "240",
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media,
        "type": "video/mp4"
      }
    })]) : _c('img', {
      staticClass: "rounded",
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "object-fit": "cover"
      },
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media,
        "alt": ""
      }
    })])])])]) : _c('div', [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), (post.gallery_post_media) ? _c('div', {
      staticClass: "row"
    }, [(post.gallery_post_media.length > 1) ? _c('div', {
      staticClass: "post-media-set"
    }, _vm._l((post.gallery_post_media), function(img, imdex) {
      return _c('li', [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.showPostImage(img)
          }
        }
      }, [(_vm.checkIfVideo(img.gallery_post_media)) ? _c('img', {
        staticClass: "rounded",
        staticStyle: {
          "width": "2em",
          "height": "2em",
          "object-fit": "cover"
        },
        attrs: {
          "src": "/static/assets/images/video-placeholder.png",
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "rounded",
        staticStyle: {
          "width": "2em",
          "height": "2em",
          "object-fit": "contain"
        },
        attrs: {
          "src": img.gallery_post_media,
          "alt": ""
        }
      })])])
    })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "row",
      staticStyle: {
        "margin-top": "0.7em"
      }
    }, [_c('h2', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v(_vm._s(post.gallery_post_caption) + "\r\n                                            "), (post.gallery_post_product_items) ? _c('span', [_vm._v("(£" + _vm._s(post.gallery_post_product_items[0].product_item_price) + ")")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('p', {
      staticStyle: {
        "white-space": "pre-line"
      }
    }, [_vm._v(_vm._s(post.gallery_post_details))])])])])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.gallery.gallery_posts_group_type == 2) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "swiper-pagination",
    staticStyle: {
      "margin-left": "0.2em",
      "text-align": "center"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('swiper', {
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.gallery.gallery_posts_group_posts), function(post, pdex) {
    return _c('swiper-slide', {
      key: post.gallery_post_id
    }, [_c('div', {
      staticClass: "container"
    }, [_c('component-product', {
      attrs: {
        "productMain": post.gallery_post_product_details
      }
    })], 1)])
  }))], 1) : _vm._e()])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "6em"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/loader.gif"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cd5c1e3"}!./src/pages/Home/template.html
// module id = 197
// module chunks = 1